import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { NextButton, SecondaryButton } from '../../styles/LayoutButtons';
import { isDefined } from 'ts-utils';

type Props = {
  primaryButtonTitle: string;
  onPressPrimaryButton?: () => void;
  primaryButtonDisabled?: boolean;
  secondaryButtonTitle?: string;
  onPressSecondaryButton?: () => void;
  /** Where the secondary action sits relative to the primary button. Defaults to above. */
  secondaryButtonPlacement?: 'above' | 'below';
  secondaryButtonTestId?: string;
};

export const LayoutActions: FunctionComponent<Props> = (props) => {
  const secondaryButton = isDefined(props.secondaryButtonTitle) &&
    isDefined(props.onPressSecondaryButton) && (
      <SecondaryButton
        onClick={props.onPressSecondaryButton}
        data-test={props.secondaryButtonTestId}
      >
        {props.secondaryButtonTitle}
      </SecondaryButton>
    );
  const below = props.secondaryButtonPlacement === 'below';

  return (
    <LayoutContainer>
      {!below && secondaryButton}
      <NextButton disabled={props.primaryButtonDisabled} onClick={props.onPressPrimaryButton}>
        {props.primaryButtonTitle}
      </NextButton>
      {below && secondaryButton}
    </LayoutContainer>
  );
};

const LayoutContainer = styled.div`
  margin: ${({ theme }) => `${theme.spacing._40px} auto ${theme.spacing._80px}`};
  text-align: center;
  padding-bottom: ${({ theme }) => theme.spacing._40px};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing._8px};
`;
